import React from "react";
import classNames from "classnames";

const InputWithLabel = (props) => {
    const highlightInError = props.highlightError ? "idea-attribute--required" : null;
    return (
        <div inputId={props.inputId} className={classNames("pure-control-group", highlightInError)}>
            <label htmlFor={props.inputId}>{props.label}</label>
            <input id={props.inputId}
                   className="idea-attribute__input"
                   type={props.type}
                   value={props.value}
                   onChange={(event) => props.onChange(event.currentTarget.value)}/>
        </div>
    );
};

InputWithLabel.propsTypes = {
    className: React.PropTypes.string,
    highlightError: React.PropTypes.bool,
    inputId: React.PropTypes.string,
    label: React.PropTypes.string,
    onChange: React.PropTypes.func,
    type: React.PropTypes.string.isRequired,
    value: React.PropTypes.string
};

export default InputWithLabel;


/** WEBPACK FOOTER **
 ** ./src/main/javascript/authentication/components/InputWithLabel.js
 **/